import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import i18n from 'i18n';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  urlConnectionRemoteApp: string;
}

const SimulateRdp = ({ urlConnectionRemoteApp }: Props) => {
  const classes = useStyles();
  const [step, setStep] = React.useState(0);

  const title = React.useMemo(() => {
    const first = urlConnectionRemoteApp.split('address:s:')[1];
    return first.split('username')[0].slice(0, 13);
  }, [urlConnectionRemoteApp]);

  const handleDowloadFile = () => {
    const data = new Blob([urlConnectionRemoteApp], { type: 'text/plain' });
    const link = window.document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = `${title}.rdp`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  };

  return (
    <Grid
      className={classes.loadingContainer}
      style={{
        marginTop: 250,
      }}
    >
      <img
        className={classes.loadingAppLogo}
        src="/images/AutoSkyLogoColorido.svg"
        alt="skyone logo"
      />
      {step === 0 ? (
        <>
          <Typography className={classes.loadingAppText}>
            {i18n.t('APPLICATIONS_PAGE.ACCESS_TRAINING_APP_KEY')}
          </Typography>
          <Typography className={classes.loadingAppText}>
            {i18n.t('APPLICATIONS_PAGE.DOWNLOAD_FILE_RDP_KEY')}
          </Typography>
          <button
            style={{
              border: 'none',
              marginTop: 20,
            }}
            className={classes.buttonDowloadPlugin}
            onClick={handleDowloadFile}
          >
            {i18n.t('APPLICATIONS_PAGE.DOWNLOAD_FILE_CONNECTION_KEY')}
          </button>
          <button onClick={() => setStep(1)} className={classes.buttonHelp}>
            {i18n.t('APPLICATIONS_PAGE.RDP_HELP_KEY')}
          </button>
        </>
      ) : (
        <>
          <img
            src="https://sky-static.s3.amazonaws.com/clientes/img/explicacaoacessordp.png"
            alt=""
          />
          <button className={classes.buttonHelp} onClick={handleDowloadFile}>
            {i18n.t('APPLICATIONS_PAGE.CONNECTION_FILE_KEY')}
          </button>
        </>
      )}
    </Grid>
  );
};

const mapStateToProps = ({
  clients: { urlConnectionRemoteApp, urlChromeExtension },
}: ApplicationState) => ({
  urlConnectionRemoteApp,
  urlChromeExtension,
});

export default connect(mapStateToProps, {})(SimulateRdp);
